var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BTabs',[_c('BTab',{attrs:{"title":_vm.$t('components.addComplimentary')}},[_c('AddEshantion')],1),_c('BTab',{attrs:{"title":_vm.$t('components.complimentaryList')}},[_c('EshantionList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }